export const updateWidth = width => ({
  type: "SET_VIEWPORT_WIDTH",
  width
});

export const updateHeight = height => ({
  type: "SET_VIEWPORT_HEIGHT",
  height
});



// WEBPACK FOOTER //
// ./src/actions/viewport.js